import { useMutation, useQuery } from '@tanstack/react-query';
import { queryClient } from '../index';
import { avatarKeys } from './avatar.keys';
import { getAvatar, getAvatarImage, resetAvatar, uploadAvatar } from './avatar.api';
export const useAvatarQuery = () => {
    return useQuery({
        queryKey: avatarKeys.avatar(),
        queryFn: () => getAvatar(),
        staleTime: 0
    });
};
export const useAvatarImageQuery = (avatar) => {
    return useQuery({
        queryKey: avatarKeys.image(avatar?.id ?? '', avatar?.updated_at ?? ''),
        queryFn: () => getAvatarImage(avatar.id, avatar.updated_at),
        enabled: !!avatar,
        staleTime: Infinity
    });
};
export const useUploadAvatarMutation = () => {
    return useMutation({
        mutationFn: (file) => uploadAvatar(file),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: avatarKeys.avatar() }).then();
        }
    });
};
export const useResetAvatarMutation = () => {
    return useMutation({
        mutationFn: resetAvatar,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: avatarKeys.avatar() }).then();
        }
    });
};
//# sourceMappingURL=avatar.query.js.map